const userManagementAction = {
    CREATE_USER : 'createUser',

    IMPORT_UW_LOAS : 'importUWLOAs',

    EXPORT_UW_LOAS : 'exportUWLOAs'

};

angular.module('gw-um-j2js')
    .constant('userManagementAction', userManagementAction);